<template>
  <v-container-principal>
    <div class="text-center" v-if="loading">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
    </div>
    <div v-else>
      <v-row>
        <v-col md="4" sm="6" cols="12">
          <div class="text-h5 font-weight-bold my-4 primary--text">
            Informações da reserva
          </div>
          <div class="text-subtitle-1 font-weight-bold primary--text mt-4">
            Título
          </div>
          <div class="text-h8">{{ reserva.titulo }}</div>
          <div class="text-subtitle-1 font-weight-bold primary--text mt-4">
            Responsável
          </div>
          <div class="text-h8">{{ reserva.responsavel.username }}</div>
          <div class="text-subtitle-1 font-weight-bold primary--text mt-4">
            Dias
          </div>
          <ul>
            <li v-for="dia in reserva.dias" :key="dia.id">{{ dia.dia }}</li>
          </ul>
          <v-layout class="mt-4">
            <v-flex>
              <div class="text-subtitle-1 font-weight-bold primary--text">
                A partir de
              </div>
              <div class="text-h8">{{ formataData(reserva.data_inicio) }}</div>
            </v-flex>
            <v-flex>
              <div class="text-subtitle-1 font-weight-bold primary--text">
                Até
              </div>
              <div class="text-h8">{{ formataData(reserva.data_termino) }}</div>
            </v-flex>
          </v-layout>
        </v-col>
        <v-col md="8" sm="6" cols="12">
          <v-calendario :reservas="[reserva]" @emitData="defineDiaSelecionado">
            <template v-slot:legenda>
              <div class="d-flex justify-center align-center">
                <span class="text-caption" style="margin-right: 5px"
                  >Evento cancelável:</span
                >
                <div
                  class="mr-4"
                  style="
                    background-color: #08468e;
                    height: 15px;
                    width: 55px;
                    border-radius: 4px;
                  "></div>

                <span class="text-caption" style="margin-right: 5px"
                  >Evento não cancelável:</span
                >
                <div
                  style="
                    background-color: #bdbdbd;
                    height: 15px;
                    width: 55px;
                    border-radius: 4px;
                  "></div>
              </div>
            </template>
          </v-calendario>
        </v-col>

        <v-reserva-dialog
          tipo="mdi-calendar-remove"
          :visivel="selectedOpen"
          mensagem="Alterar reserva"
          :corpoMensagem="`Você deseja cancelar ${
            reserva.titulo
          } no dia ${formataData(dataSelecionada)}?`"
          @close="selectedOpen = false">
          <v-btn
            v-if="this.reserva.data_inicio != this.reserva.data_termino"
            @click="quebrarReserva"
            class="pa-4"
            min-width="100"
            min-height="50"
            color="primary"
            outlined>
            Cancelar apenas este dia
          </v-btn>
          <v-btn
            @click="cancelarDias"
            class="pa-4"
            min-width="100"
            min-height="50"
            color="primary"
            outlined>
            {{
              this.reserva.data_inicio == this.reserva.data_termino
                ? "Cancelar Reserva"
                : "Cancelar todos os dias adiante"
            }}
          </v-btn>
          <v-btn
            @click="selectedOpen = false"
            class="pa-4 ml-6"
            min-width="100"
            min-height="50"
            color="primary">
            Sair
          </v-btn>
        </v-reserva-dialog>
      </v-row>
    </div>
  </v-container-principal>
</template>

<script>
import dayjs from "dayjs"
import { RepositoryFactory } from "@/repositories/repositoryFactory"
import dataMixin from "../mixins/dataMixin"
import VContainerPrincipal from "@/components/VContainerPrincipal"
import VReservaDialog from "@/components/base/VDialogReservaqui.vue"
import VCalendario from "../components/VCalendario.vue"
import { mapGetters, mapActions } from "vuex"

const reservaRepository = RepositoryFactory.get("reserva")

const DIA_CANCELADO = "Data cancelada com sucesso!"
const DIA_ERRO = "Houve um erro ao alterar a reserva..."

export default {
  components: { VContainerPrincipal, VCalendario, VReservaDialog },
  props: ["id"],
  mixins: [dataMixin],

  data: () => ({
    loading: true,
    dataSelecionada: new Date(),
    reserva: {},
    selectedOpen: false,
  }),

  mounted() {
    reservaRepository
      .getOne(this.id)
      .then((response) => {
        const reserva = response.data.data.attributes
        this.reserva = {
          responsavel: Object.assign(reserva.responsavel.data.attributes, {
            id: reserva.responsavel.data.id,
          }),
          titulo: reserva.titulo,
          status: reserva.status,
          justificativa: reserva.justificativa,
          sala: reserva.sala.data.id,
          data_inicio: reserva.data_inicio,
          data_termino: reserva.data_termino,
          horario_inicio: reserva.horario_inicio,
          horario_termino: reserva.horario_termino,
          dias: reserva.dias,
          participantes: reserva.participantes,
          computadores: reserva.computadores,
          arcondicionado: reserva.arcondicionado,
          projetor: reserva.projetor,
          mesa: reserva.mesa,
          lousa: reserva.lousa,
        }
      })
      .finally(() => {
        this.loading = false
        if (
          !this.isAdministrador &&
          this.userId != this.reserva.responsavel.id
        ) {
          this.$router.replace({ name: "acessoNegado" })
        }
      })
  },

  computed: {
    ...mapGetters({
      nome: ["auth/username"],
      userId: ["auth/userId"],
      isAdministrador: ["auth/isAdministrador"],
    }),
  },

  methods: {
    defineDiaSelecionado(dia) {
      this.dataSelecionada = dia
      this.selectedOpen = true
      return dia
    },
    corrigeStatus(dataTermino) {
      let status = this.reserva.status
      if (dayjs(dataTermino).isBefore(dayjs(this.reserva.data_inicio))) {
        status = "Cancelada"
      }
      return status
    },
    quebrarReserva() {
      const tempDataSelecionada = dayjs(this.dataSelecionada).format(
        "YYYY-MM-DD"
      )
      let statusAtual = this.reserva.status
      let novaDataInicio = dayjs(tempDataSelecionada).format("YYYY-MM-DD")
      let novaDataTermino = dayjs(tempDataSelecionada).format("YYYY-MM-DD")
      let dataInicio = dayjs(this.reserva.data_inicio).format("YYYY-MM-DD")
      let dataTermino = dayjs(this.reserva.data_termino).format("YYYY-MM-DD")

      if (dataInicio == dataTermino) {
        statusAtual = "Cancelada"
        this.editarData(dataInicio, dataTermino, statusAtual)
      } else if (tempDataSelecionada == dataInicio) {
        novaDataInicio = dayjs(tempDataSelecionada)
          .add(1, "day")
          .format("YYYY-MM-DD")
        this.editarData(novaDataInicio, dataTermino, statusAtual)
      } else if (tempDataSelecionada == dataTermino) {
        novaDataTermino = dayjs(tempDataSelecionada)
          .subtract(1, "day")
          .format("YYYY-MM-DD")
        this.editarData(dataInicio, novaDataTermino, statusAtual)
      } else {
        novaDataInicio = dayjs(tempDataSelecionada)
          .add(1, "day")
          .format("YYYY-MM-DD")
        novaDataTermino = dayjs(tempDataSelecionada)
          .subtract(1, "day")
          .format("YYYY-MM-DD")
        this.editarData(dataInicio, novaDataTermino, statusAtual).then(() => {
          this.criarNovoDia(novaDataInicio, dataTermino)
        })
      }
      this.selectedOpen = false
    },
    cancelarDias() {
      const tempDataSelecionada = dayjs(this.dataSelecionada).format(
        "YYYY-MM-DD"
      )
      let dataInicio = dayjs(this.reserva.data_inicio).format("YYYY-MM-DD")
      let dataTermino = dayjs(this.reserva.data_termino).format("YYYY-MM-DD")
      let novaDataTermino = dayjs(tempDataSelecionada)
        .subtract(1, "day")
        .format("YYYY-MM-DD")
      let statusAtual = this.reserva.status
      this.corrigeStatus(novaDataTermino)
      if (tempDataSelecionada == dataInicio) {
        statusAtual = "Cancelada"
        this.editarData(dataInicio, dataTermino, statusAtual)
      } else {
        this.editarData(this.reserva.data_inicio, novaDataTermino, statusAtual)
      }
      this.selectedOpen = false
    },
    editarData(novaDataInicio, novaDataTermino, statusAtualizado) {
      const {
        responsavel,
        titulo,
        justificativa,
        participantes,
        computadores,
        arcondicionado,
        projetor,
        mesa,
        lousa,
        sala,
        horario_inicio,
        horario_termino,
        dias,
      } = this.reserva
      return reservaRepository
        .update(this.id, {
          data: {
            responsavel: responsavel.id,
            titulo,
            justificativa,
            participantes,
            computadores,
            arcondicionado,
            projetor,
            mesa,
            lousa,
            sala,
            status: statusAtualizado,
            data_inicio: novaDataInicio,
            data_termino: novaDataTermino,
            horario_inicio,
            horario_termino,
            dias,
          },
        })
        .then((response) => {
          this.reserva.data_inicio = response.data.data.attributes.data_inicio
          this.reserva.data_termino = response.data.data.attributes.data_termino
          this.showSucesso(DIA_CANCELADO)
        })
        .catch(() => {
          this.showErro(DIA_ERRO)
        })
    },
    criarNovoDia(NdataInicio, tempDataTermino) {
      const {
        responsavel,
        titulo,
        justificativa,
        participantes,
        computadores,
        arcondicionado,
        projetor,
        mesa,
        lousa,
        sala,
        horario_inicio,
        horario_termino,
        dias,
      } = this.reserva
      reservaRepository
        .create({
          data: {
            responsavel: responsavel.id,
            titulo: titulo.endsWith("*") ? titulo : titulo + "*",
            justificativa,
            participantes,
            computadores,
            arcondicionado,
            projetor,
            mesa,
            lousa,
            sala,
            status: "Confirmado",
            data_inicio: NdataInicio,
            data_termino: tempDataTermino,
            horario_inicio,
            horario_termino,
            dias,
          },
        })
        .then(() => {
          this.showSucesso(DIA_CANCELADO)
        })
        .catch(() => {
          this.showErro(DIA_ERRO)
        })
    },
    ...mapActions("message", ["showSucesso", "showErro"]),
  },
}
</script>
